import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { ToasterService } from 'angular2-toaster';
import { clientOutService } from '../../../services/index';
import { clientOutComponent } from '../../common/clientOut.component';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import swal from 'sweetalert2';

@Component({
    selector: 'client-out-pending-report-tab',
    templateUrl: './clientOutPendingReport.component.html'
})
export class ClientOutPendingReportComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

    bsModalRef: BsModalRef;
    isLoadMask: Promise<any>;
    loadingIndicator = true;
    suppressPaging = false;
    scrollTimeout: any;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: '',
        orderDir: 'desc'
    };

    filterData: any = {
        from_date: new Date(),
        to_date: new Date(),
        without_date: false,
        branch_id: '',
        page_type: '',
        search_name: ''
    };

    reportData: any[] = [];
    columns: any[] = [];
    usertype: string = '';
    initialized = false;
    isSendingEmail = false;
    summary: any = { total: 0, items: [] };

    branchList: any[] = [];
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;

    pageTypeList: any[] = [];
    pageTypeCtrl: FormControl;
    filteredPageType: Observable<any[]>;

    constructor(
        private clientOutSvc: clientOutService,
        private toasterService: ToasterService,
        private store: Store<any>,
        private modalService: BsModalService
    ) {}

    ngOnInit() {
        let that = this;
        this.branchCtrl = new FormControl();
        this.pageTypeCtrl = new FormControl();

        this.filteredPageType = this.pageTypeCtrl.valueChanges
            .startWith(null)
            .map(val => val ? that.filterPageType(val) : that.pageTypeList.slice());

        this.loadPageTypes();

        this.store.select(fromCommonStore.getAuth).take(1).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.usertype = auth['usertype'];
                if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts') {
                    that.branchCtrl.setValue(auth['branch_id']);
                    that.branchCtrl.disable();
                }
                that.initialized = true;
                that.getReports();
            }
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (!_.isEmpty(res.data)) {
                that.branchList = res.data;
                that.filteredBranch = that.branchCtrl.valueChanges
                    .startWith(null)
                    .map(val => val ? that.filterBranch(val) : that.branchList.slice());
            }
        });
    }

    loadPageTypes() {
        let that = this;
        this.clientOutSvc.getPageTypes().then((res: any) => {
            if (res && res.data && res.data.length) {
                that.pageTypeList = res.data;
                that.pageTypeCtrl.setValue(that.pageTypeCtrl.value || '');
            }
        }).catch(() => {
            // fallback maintained
        });
    }

    ngOnChanges() {
        if (this.active && this.initialized) {
            this.getReports();
        }
    }

    filterBranch(val: any) {
        if (!val || typeof val !== 'string') { return this.branchList.slice(); }
        return this.branchList.filter(b => b.branch_name.toLowerCase().includes(val.toLowerCase()));
    }

    displayBranchFn(branch_id: any) {
        if (!branch_id) { return ''; }
        let item = _.find(this.branchList, { 'branch_id': branch_id });
        return item ? item.branch_name : '';
    }

    filterPageType(val: any) {
        if (!val || typeof val !== 'string') { return this.pageTypeList.slice(); }
        return this.pageTypeList.filter(p => p.name.toLowerCase().includes(val.toLowerCase()));
    }

    displayPageTypeFn(page_type_id: any) {
        if (!page_type_id) { return ''; }
        let item = _.find(this.pageTypeList, { 'id': page_type_id });
        return item ? item.name : page_type_id;
    }

    onWithoutDateChange() {
        if (!this.filterData.without_date) {
            if (!this.filterData.from_date) {
                this.filterData.from_date = new Date();
            }
            if (!this.filterData.to_date) {
                this.filterData.to_date = new Date();
            }
        }
    }

    onSearch() {
        this.page.offset = 0;
        this.getReports();
    }

    onReset() {
        this.filterData = {
            from_date: new Date(),
            to_date: new Date(),
            without_date: false,
            branch_id: '',
            page_type: '',
            search_name: ''
        };
        this.branchCtrl.reset();
        this.pageTypeCtrl.reset();
        this.page.offset = 0;
        this.getReports();
    }

    getSummaryBadgeClass(key: string): string {
        switch (key) {
            case 'Client Walk-in':  return 'copr-s-walkin';
            case 'HV Entry':        return 'copr-s-hv';
            case 'HV Appointment':  return 'copr-s-hv';
            case 'SOA Entry':       return 'copr-s-soa';
            case 'SOA Appointment': return 'copr-s-soa';
            case 'SG Promo':        return 'copr-s-sgpromo';
            case 'DR Promo':        return 'copr-s-drpromo';
            case 'Store Promo':     return 'copr-s-store';
            default:                return 'copr-s-branch';
        }
    }

    openClientOutModal(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(clientOutComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-75'
        });
        row['page_from'] = row['page_type'];
        row['tabParams'] = row['page_type'];
        row['date'] = row['date'] || moment(row['walkin_date'], 'DD-MM-YYYY').format('YYYY-MM-DD');
        this.bsModalRef.content.clientStatus = Object.assign({}, row);
        this.bsModalRef.content.clientOutLoadEvent.subscribe(() => {
            that.getReports();
        });
    }

    pageCallback(pageInfo: any) {
        this.page.offset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page - 1);
        if (!this.suppressPaging) { this.getReports(); }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    getReports() {
        let that = this;
        let params: any = {
            from_date: this.filterData.without_date ? '' : moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: this.filterData.without_date ? '' : moment(this.filterData.to_date).format('YYYY-MM-DD'),
            without_date: this.filterData.without_date ? '1' : '0',
            branch_id: this.branchCtrl.value || '',
            page_type: this.pageTypeCtrl.value || this.filterData.page_type || '',
            search: this.filterData.search_name || '',
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`
        };

        this.isLoadMask = this.clientOutSvc.getPendingOutStatusReport(params).then(function (res: any) {
            that.loadingIndicator = false;
            that.reportData = res.data || [];
            that.page.count = res.totCnt || 0;
            that.columns = res.columns || [];
            if (res.summary) { that.summary = res.summary; }
            if (res.pageTypes && res.pageTypes.length) {
                that.pageTypeList = res.pageTypes;
                that.pageTypeCtrl.setValue(that.pageTypeCtrl.value || '');
            }
        }).catch(function () {
            that.loadingIndicator = false;
            that.toasterService.pop('error', 'Error', 'Failed to load report');
        });
    }

    onExcelExport() {
        let that = this;
        let params: any = {
            from_date: this.filterData.without_date ? '' : moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: this.filterData.without_date ? '' : moment(this.filterData.to_date).format('YYYY-MM-DD'),
            without_date: this.filterData.without_date ? '1' : '0',
            branch_id: this.branchCtrl.value || '',
            page_type: this.pageTypeCtrl.value || this.filterData.page_type || '',
            search: this.filterData.search_name || '',
            start: '0',
            limit: '99999'
        };
        this.clientOutSvc.getPendingOutStatusReport(params).then(function (res: any) {
            let data: any[] = res.data || [];
            let cols: any[] = res.columns || [];
            if (!data.length) { return; }
            let wsData: any[][] = [];
            wsData.push(cols.map((c: any) => c.name));
            data.forEach((row: any) => {
                wsData.push(cols.map((c: any) => row[c.prop] !== undefined ? row[c.prop] : ''));
            });
            let XLSX = require('xlsx');
            let wb = { SheetNames: ['Report'], Sheets: {} };
            wb.Sheets['Report'] = XLSX.utils.aoa_to_sheet(wsData);
            XLSX.writeFile(wb, 'ClientOutPendingReport_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '.xlsx');
        });
    }

    emailModalRef: BsModalRef;
    emailModalData: any = {
        custom_emails: ''
    };

    openEmailModal(template: TemplateRef<any>) {
        this.emailModalData = {
            custom_emails: ''
        };
        this.emailModalRef = this.modalService.show(template, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-md'
        });
    }

    closeEmailModal() {
        if (this.emailModalRef) {
            this.emailModalRef.hide();
        }
    }

    submitSendEmail() {
        let that = this;
        if (!this.emailModalData.custom_emails || !this.emailModalData.custom_emails.trim()) {
            this.toasterService.pop('warning', 'Validation', 'Please enter at least one recipient Email ID.');
            return;
        }

        this.isSendingEmail = true;
        const emailParams = {
            from_date: that.filterData.without_date ? '' : moment(that.filterData.from_date).format('YYYY-MM-DD'),
            to_date: that.filterData.without_date ? '' : moment(that.filterData.to_date).format('YYYY-MM-DD'),
            without_date: that.filterData.without_date ? '1' : '0',
            branch_id: that.branchCtrl.value || '',
            page_type: that.pageTypeCtrl.value || that.filterData.page_type || '',
            send_branch_email: '0',
            custom_emails: that.emailModalData.custom_emails ? that.emailModalData.custom_emails.trim() : ''
        };

        this.clientOutSvc.sendPendingOutStatusEmail(emailParams).then((res: any) => {
            that.isSendingEmail = false;
            if (res.success) {
                that.toasterService.pop('success', 'Email Sent', res.message);
                that.closeEmailModal();
            } else {
                that.toasterService.pop('error', 'Email Error', res.message);
            }
        }).catch(() => {
            that.isSendingEmail = false;
            that.toasterService.pop('error', 'Error', 'Failed to send email alert.');
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/clientOutPendingReport/clientOutPendingReport.component.ts